import ProductPicknmix from './components/ProductPicknmix'
import VueCart from './components/VueCart'
import Quantity from './components/Quantity'
import pageContext from 'salvo-lite/context'
import ChangeClass from './components/ChangeClass'
import Select from './components/Select'
import Slick from './components/Slick'
import Preload from './components/Preload'
import GEOIP from './components/GEOIP'
import SetViewportHeight from './components/SetViewportHeight'
import ActiveInput from './components/ActiveInput'
import ModalDisplay from './components/ModalDisplay'
import Nosto from './components/Nosto'
import Account from './components/Account'
import Slide from './components/Slide'
import Sticky from './components/Sticky'
import ScrollTo from './components/ScrollTo'
import ProxyDropdown from './components/ProxyDropdown'
import Variants from './components/Variants'
import StickyHeader from './components/StickyHeader'
import StoreFilter from './components/StoreFilter'
import ScrollClass from './components/ScrollClass'
import HoverZoom from './components/HoverZoom'
import InViewport from './components/InViewport'
// import Cart from './components/Cart'
// import AjaxCart from './components/AjaxCart'
import Bundle from './components/Bundle'
import YotpoSignUp from './components/YotpoSignUp'
import Checkout from './components/Checkout'
import ForceVariants from './components/ForceVariants'

import Addresses from './pages/Addresses'
import Login from './pages/Login'
import Product from './pages/Product'

const components = {
    'product-picknmix': ProductPicknmix,
    'vue-cart': VueCart,
    'quantity': Quantity,
    'change-class': ChangeClass,
    'select': Select,
    'slick': Slick,
    'preloader': Preload,
    'geoip': GEOIP,
    'set-viewport-height': SetViewportHeight,
    'active-element': ActiveInput,
    'modal-display': ModalDisplay,
    'nosto-slider': Nosto,
    'account-alternative': Account,
    'slide': Slide,
    'sticky': Sticky,
    'scroll-to': ScrollTo,
    'proxy-dropdown': ProxyDropdown,
    'variants': Variants,
    'bundle': Bundle,
    'sticky-header': StickyHeader,
    'store-filter': StoreFilter,
    'scroll-class': ScrollClass,
    'hover-zoom': HoverZoom,
    'in-viewport': InViewport,
    'yotpo-signup': YotpoSignUp,
    'checkout': Checkout,
    'force-variants': ForceVariants
}

const pages = {
    'customers/addresses': Addresses,
    'customers/login': Login,
    'product': Product
}

if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = Array.prototype.forEach
}

Nosto.createCartEvent()

class Theme {
    constructor () {
        this._components = []
        this._componentsById = {}

        if (document.querySelector('[data-theme-locale]')) {
            this.locale = JSON.parse(document.querySelector('[data-theme-locale]').innerHTML)
        } else {
            this.locale = {}
        }

        if (document.querySelector('[data-shop-info]')) {
            this.shopInfo = JSON.parse(document.querySelector('[data-shop-info]').innerHTML)
        } else {
            this.shopInfo = {
                currency: 'GBP',
                moneyFormat: '£{{amount}}'
            }
        }
    }

    registerComponents (container = document) {
        for (let key in components) {
            var ComponentConstructor = components[key]
            var elements = container.querySelectorAll(`.js-component__${key}, [data-${key}]`)
            for (let elem of elements) {
                var instance = new ComponentConstructor(this, elem)
                this._components.push(instance)
                var id = elem.dataset.componentId
                if (id) {
                    this._componentsById[id] = instance
                }
                instance.onInit()
            }
        }
        window.ThemeComponents = this._components
        window.ThemeComponentsId = this._componentsById
        window.__Theme = this
    }

    registerPages () {
        var context = pageContext.getTemplate()
        for (let page in pages) {
            if (page === context) {
                var instance = new pages[page](this)
                instance.onInit()
            }
        }
    }

    getComponents () {
        return this._components
    }

    getComponentsById (id) {
        return this._componentsById[id]
    }

    getComponentsByType (componentConst, includeSubclasses = true) {
        var r = []
        for (let c of this._components) {
            if (includeSubclasses && c instanceof componentConst) {
                r.push(c)
            } else if (c.constructor === componentConst) {
                r.push(c)
            }
        }
        return r
    }
}

export default Theme



// WEBPACK FOOTER //
// ./src/resources/scripts/Theme.js